export enum InflightInclusionState {
  NONE,
  ENABLED,
  DISABLED,
}

export namespace InflightInclusionState {
  let elements = [
    InflightInclusionState.NONE,
    InflightInclusionState.ENABLED,
    InflightInclusionState.DISABLED,
  ];
  let alias = "com.bcdfx.model.InflightInclusionState";

  export function RemoteClass() {
    return alias;
  }

  export function getAllElements() {
    return elements;
  }
}
